import {
  HttpGetRequest,
  HttpPostRequest,
  HttpPutRequest,
} from "./HttpRequest.js";

export async function create(user) {
  let url = "/surgical_procedure";
  return await HttpPostRequest(url, user).then((response) => {
    return response.json();
  });
}

export async function update(id, user) {
  let url = "/surgical_procedure/" + id;
  return await HttpPutRequest(url, user).then((response) => {
    return response.json();
  });
}

export async function getOne(userId) {
  let url = "/surgical_procedure/" + userId;
  return await HttpGetRequest(url).then((response) => {
    return response.json();
  });
}

export async function all(payload) {
  let url = "/surgical_procedures";
  return await HttpPostRequest(url, payload).then((response) => {
    return response.json();
  });
}
